import _ from 'lodash'
import {daysFromDate, minutes, isPast, getDateObject, countDaysAgo} from '@/helpers/date'
import {currentUserId} from '@/firebase/firebase'

export default {
  user: (state) => state.user || {},
  userOlderThan5min: (state, getters) => {
    const registeredAt = getters.user.registeredAt

    return ((new Date) - registeredAt) > minutes(600)
  },
  atLeastFiveVisits: (state, getters) => {
    return getters.user.activeDays && getters.user.activeDays >= 5
  },
  atLeastVisits: (state, getters) => (visits) => {
    return getters.user.activeDays && getters.user.activeDays >= visits
  },
  numberForToday: (state, getters) => (max) => {
    if (getters.user.activeDays) {
      return (getters.user.activeDays - 1) % max
    } else {
      return 0
    }
  },
  keyword: (state, getters) => _.get(getters.user, 'userInfo.keyword'),
  adgroup: (state, getters) => _.get(getters.user, 'userInfo.adgroup'),
  creative: (state, getters) => _.get(getters.user, 'userInfo.creative'),
  campaign: (state, getters) => _.get(getters.user, 'userInfo.campaign'),
  channel: (state, getters) => _.get(getters.user, 'userInfo.channel'),
  country: (state, getters) => _.get(getters.user, 'location.country'),
  landbotMessage: (state, getters) => _.get(getters.user, 'landbotMessage'),
  onboardingPath:(state, getters) => _.get(getters.user, 'userInfo.onboardingPath'),
  inviter:(state, getters) => _.get(getters.user, 'userInfo.inviter'),
  wishTo: (state, getters) => {
    if (getters.user.whatAreYouTryingToSolve) {
      if (getters.user.whatAreYouTryingToSolve) {
        return _.join(getters.user.whatAreYouTryingToSolve, ", ")
      }
    }
  },
  priceVariant: (state, getters) => getters.user.priceVariant,
  activeDays: (state, getters) => getters.user.activeDays,
  rewardful: (state, getters) => getters.user.rewardful,
  backgroundImageName: (state) => state.user.backgroundImageName,
  firstChapter: (state) => state.user.firstChapter,
  helloAndWelcomeStarted: (state, getters) => getters.userAdditionalInfo.helloAndWelcomeStarted,
  helloAndWelcomeEnded: (state, getters) => getters.userAdditionalInfo.helloAndWelcomeEnded,
  notificationClicked: (state, getters) => getters.userAdditionalInfo.notificationClicked,
  notificationsOpened: (state, getters) => getters.userAdditionalInfo.notificationsOpened,
  interestedInReferral: (state, getters) => getters.userAdditionalInfo.interestedInReferral,
  aiTipsDisabled: (state, getters) => getters.userAdditionalInfo.aiTipsDisabled,
  showTrialJourneyStartedSeen: (state, getters) => getters.userAdditionalInfo.showTrialJourneyStartedSeen,
  academyRequested: (state) => state.user.academyRequested,
  userRegisteredAt: (state, getters) => getters.user.registeredAt,
  fcm_token: (state, getters) => getters.user.fcm_token,
  userEmail: (state, getters) => getters.user.userInfo.email,
  userAge: (state, getters) => getters.user.userInfo.iAmAge,
  userStatus: (state, getters) => getters.user.userInfo.iAmOccup,
  userPositive: (state, getters) => _.join(getters.user.userInfo.positive),
  userNegative: (state, getters) => _.join(getters.user.userInfo.negative),
  userInfo: (state, getters) => getters.user.userInfo,
  isAnonymous: (state, getters) => getters.userInfo.isAnonymous,
  lastReviewFor: (state, getters) => getters.user.lastReviewFor,
  filter: (state, getters) => getters.user.filter,
  betaFeatures: (state, getters) => getters.user.admin || getters.userId === 'erzPJ0Q5Ysd18I9hjMwHjZEwu7f1',
  trialLength: (state, getters) => getters.trialMembership.trialLength,
  trialMembership: (state, getters) => getters.user.trialMembership || {},
  userMembership: (state, getters) => {
    if (!getters.user.membership || getters.user.membership.tarif === 'free') {
      return { tarif: 'free' }
    }

    if (getters.user.membership.tarif === 'pretrial') {
      return getters.user.membership
    }

    if (getters.user.membership.endsOn &&
      isPast(getDateObject(getters.user.membership.endsOn)) &&
      getters.user.membership.tarif !== 'regular') {
      return { tarif: 'expired' }
    }

    return {
      tarif: getters.user.membership.tarif,
      endsOn: getDateObject(getters.user.membership.endsOn)
    }

  },
  hasMembershipExpired: (state, getters) => getters.userMembership.tarif === 'expired',
  userPreferences: (state, getters) => getters.user.userPreferences || {},
  showMonthToMonthWizard: (state, getters) => getters.user.showMonthToMonthWizard,
  onboardingFinished: (state, getters) => {
    const onboardingImplementedAt = new Date(2020, 8, 28)
    const user = getters.user

    if (user.registeredAt) {
      return user.registeredAt < onboardingImplementedAt || !!user.onboardingFinished
    } else {
      return undefined
    }
  },
  userName: (state, getters) => _.get(getters.user, 'userInfo.displayName') || '',
  userNameLandbot: (state, getters) => getters.userEmail || getters.userId,
  userId: (state, getters) => currentUserId(),
  userFirstName: (state, getters) => _.chain(getters.userName)
    .split(' ')
    .first()
    .capitalize()
    .value(),
  daysFromRegistration: (state, getters) => {
    return getters.user.registeredAt ? daysFromDate(getters.user.registeredAt) : -1
  },
  trialEndedAgo: (state, getters) => {
    if (getters.user.trialMembership) {
      return countDaysAgo(getters.user.trialMembership.endsOn)
    }
  },
  trialEndsOn: (state, getters) => {
    if (getters.user.trialMembership) {
      return getters.user.trialMembership.endsOn
    }
  },
  stripeCustomerId: (state, getters) => getters.user.stripeCustomerId,
  invoiceOverdue: (state, getters) => getters.user.invoiceOverdue,
  userAdditionalInfo: (getters) => getters.user.additionalInfo || {},
}
